export const AUDIO_REFERRAL_SOURCES_TO_KEYS = {
  Podcast: 'podcast',
  Radio: 'radio',
  'Streaming Audio (Pandora, TuneIn)': 'streamingAudio',
  SiriusXM: 'siriusxm',
  YouTube: 'youtube',
  TV: 'tv',
} as const

export const AUDIO_REFERRAL_SOURCES: readonly string[] = Object.keys(
  AUDIO_REFERRAL_SOURCES_TO_KEYS,
)

export type AudioReferralSource = keyof typeof AUDIO_REFERRAL_SOURCES_TO_KEYS

// Lands in Segment as `audio_referral_sources`; keep the straight apostrophe
// (the hdyhau ingestion normalizes ’ to ') and never move it into i18n.
export const MASTERCLASS_PODCAST_AUDIO_SOURCE =
  "Other People's Business (MasterClass podcast)"

// Most-picked podcasts by unique users on `Audio Referral Sources Completed`
// (Amplitude, Oct 2025 – Sep 2026), stopping before the shows that only rank
// high because they sort first. Names that no longer match the sheet are skipped.
export const TOP_PODCAST_AUDIO_SOURCES: readonly string[] = [
  'We Can Do Hard Things with Glennon Doyle',
  'The Mel Robbins Podcast',
  'The Joe Rogan Experience',
  "Penn's Sunday School",
  'I Will Teach You To Be Rich',
  'Armchair Expert with Dax Shepard',
  'Morbid: A True Crime Podcast',
]

// Must match the `"Other"` row the backend pins last (referral_source.rb).
export const OTHER_REFERRAL_SOURCE = 'Other'
